// ============================================================================
// view.clientErrors — the admin client-error review page, read locally
// ============================================================================
// /admin/client-errors renders one list from one admin-only SECDEF RPC. There
// was no App hand-off to take back: `clientErrors` sits in the
// noFormerEagerCohort of tests/fixtures/former-eager-dependencies.json, so it
// consumes no result of any of the five formerly-eager global reads, and its
// route-local read was already page-owned. What moved is the OWNERSHIP of that
// read — cursor, scope key and cancellation — from a mount effect into
// clientErrors.page.
//
// THE PANEL IS MOUNTED TWICE, AND BOTH OWNERS SHARE ONE RESOURCE.
//
// view.webforms now releases alongside this route and declares
// clientErrors.page as its own permanent obligation. ClientErrorsRoutePanel is
// therefore the single cursor/retry/readiness owner for both mounts, while
// ClientErrorsTable remains presentation-only. This is not a resource leak:
// both declared surfaces are permanent and listed in the catalog row.

// residualLegacy is empty and that is a real claim rather than an omission:
// this page reads no App context and mounts only the shared Header, which is
// separately owned chrome on every authenticated surface.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.clientErrors',
  obligations: Object.freeze([Object.freeze({id: 'clientErrors.page', owner: 'permanent'})]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
